import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MzicSvgComponent } from '@mzic/mzic-components';

@Component({
  selector: 'mzic-area-items',
  imports: [CommonModule, MzicSvgComponent],
  templateUrl: './area-items.component.html',
  styleUrls: ['./area-items.component.scss'],
})
export class AreaItemsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}